import { FC } from 'react';
import { NotFound } from './NotFound';
import { path } from '../paths';
import { SectionObject } from '../common/types';
import translations from './Settings.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Section } from '../common/Section';
import { Navigate } from 'react-router-dom';
import { SystemClassifiers } from './system-classifiers/SystemClassifiers';
import { AccessGroups } from './access-groups/AccessGroups';
import { DataObjectGroups } from './data-object-groups/DataObjectGroups';
import { Roles } from './roles/Roles';

const { addTranslations, Translation } = i18nNsFactory('settings');
addTranslations(translations);

const settingsSections: SectionObject[] = [
  {
    key: 'system-classifiers',
    id: 'system-classifiers-menu-item',
    label: <Translation>{(t) => t('menu.system-classifiers')}</Translation>,
    route: {
      path: path.systemClassifierDirectory + '/*',
      element: <SystemClassifiers basePath={path.systemClassifierDirectory} />,
    },
  },
  {
    key: 'data-object-groups',
    id: 'data-object-groups-menu-item',
    label: <Translation>{(t) => t('menu.data-object-groups')}</Translation>,
    route: {
      path: path.dataObjectGroupDirectory + '/*',
      element: <DataObjectGroups basePath={path.dataObjectGroupDirectory} />,
    },
  },
  {
    key: 'access-groups',
    id: 'access-groups-menu-item',
    label: <Translation>{(t) => t('menu.access-groups')}</Translation>,
    route: {
      path: path.accessGroupDirectory + '/*',
      element: <AccessGroups basePath={path.accessGroupDirectory} />,
    },
  },
  {
    key: 'roles',
    id: 'roles-menu-item',
    label: <Translation>{(t) => t('menu.roles')}</Translation>,
    route: {
      path: path.roleDirectory + '/*',
      element: <Roles basePath={path.roleDirectory} />,
    },
  },
  {
    key: 'redirect-to-first-section',
    id: 'redirect-to-first-section-menu-item',
    route: {
      path: '/',
      element: <Navigate to={path.systemClassifierDirectory} replace />,
    },
    hiddenFromMenu: true,
  },
  {
    key: 'not-found',
    id: 'not-found-menu-item',
    route: {
      path: '*',
      element: <NotFound />,
    },
    hiddenFromMenu: true,
  },
];

export const Settings: FC<{ basePath: string }> = ({ basePath }) => (
  <Section sections={settingsSections} basePath={basePath} />
);
